// billingMapper.js
export const mapIndicatorToSegments = (indicator, program = "RPM") => {
  if (!indicator?.segments) return null;

  const s = indicator.segments;

  const readTimeSubs = (subs = {}) =>
    Object.entries(subs).map(([k, v]) => ({
      key: k,
      completed: typeof v === "boolean" ? v : Boolean(v?.completed ?? v),
    }));

  if (program === "RPM") {
    // Expand time_based into 3 separate segments, each with its own color
    const timeSegments = [
      {
        key: "time_20",
        label: "20m",
        completed: !!s.time_based?.sub_segments?.["20_min"],
        weight: 11,
      },
      {
        key: "time_40",
        label: "40m",
        completed: !!s.time_based?.sub_segments?.["40_min"],
        weight: 11,
      },
      {
        key: "time_60",
        label: "60m",
        completed: !!s.time_based?.sub_segments?.["60_min"],
        weight: 11,
      },
    ];

    return [
      {
        key: "device",
        label: "Device readings",
        completed: Boolean(s.device_readings?.completed),
        weight: 33,
      },
      {
        key: "two_way",
        label: "Two-way communication",
        completed: Boolean(s.two_way_communication?.completed),
        weight: 34,
      },
      ...timeSegments,
    ];
  }

  // CCM - expand time_based into 3 separate segments, each with its own color
  const timeSegmentsCCM = [
    {
      key: "time_40",
      label: "40m",
      completed: !!s.time_based?.sub_segments?.["40_min"],
      weight: 11,
    },
    {
      key: "time_60",
      label: "60m",
      completed: !!s.time_based?.sub_segments?.["60_min"],
      weight: 11,
    },
    {
      key: "time_80",
      label: "80m",
      completed: !!s.time_based?.sub_segments?.["80_min"],
      weight: 11,
    },
  ];

  return [
    {
      key: "care_doc",
      label: "Care plan documented",
      completed: Boolean(s.care_plan_documented?.completed),
      weight: 33,
    },
    {
      key: "care_final",
      label: "Care plan finalized",
      completed: Boolean(s.care_plan_finalized?.completed),
      weight: 34,
    },
    ...timeSegmentsCCM,
  ];
};
